import { Box } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { AdviseCurrentSupplier } from '../../../../types/advise';
import { currentMonthlySpend, dollars } from './currentSupplierSpend';

/** The supplier count, and once there are suppliers, their in-scope monthly spend. */
export const CurrentSuppliersSummary = ({ suppliers }: { suppliers: AdviseCurrentSupplier[] }) => (
  <Box className="flex items-center justify-between">
    <TextSpan
      size="xs"
      weight="semibold"
      color="grey6">
      {`CURRENT SUPPLIERS · ${suppliers.length}`}
    </TextSpan>
    {suppliers.length > 0 && (
      <Box className="flex items-center gap-2">
        <TextSpan
          size="sm"
          color="grey6">
          Current monthly spend (in scope)
        </TextSpan>
        <TextSpan
          size="sm14"
          weight="semibold"
          color="indigo">
          {dollars(currentMonthlySpend(suppliers))}
        </TextSpan>
      </Box>
    )}
  </Box>
);
